/* eslint-disable no-empty-pattern */
import React, { useEffect, useRef } from "react";
import { Fragment } from "react";
import { ReactComponent as NoticeIcon } from "../../../../../assets/img/noticeIcon.svg";
import { ReactComponent as DeleteIcon } from "../../../../../assets/icons/DeleteTeammateIcon.svg";

export default function NoticeModal({
    title,
    message,
    onSubmit,
    showCancel,
    onClose,
    loading,
    csv,
    deleteIcon,
}) {
    const wrapperRef = useRef();

    useEffect(() => {
        document.body.classList.add("backdrop-init");
        // document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.body.classList.remove("backdrop-init");
            // document.removeEventListener("mousedown", handleClickOutside);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // function handleClickOutside(event) {
    //   if (
    //     wrapperRef &&
    //     !wrapperRef.current.contains(event.target) &&
    //     !document.body.classList.contains("call-active")
    //   ) {
    //     onClose(false);
    //   }
    // }

    return (
        <div className="modal">
            <div className="modal modal-sendMoney small-modal modal-backdrop kuda-success--modal fadeIn animated modal-backdrop">
                <div ref={wrapperRef} className="modal-content kudaFadeInUp animated">
                    <div className="kuda-modal--content notice-content">
                        <h4 className="color-black text-xbold margin-bottom--spacer text-center card-main--heading">
                            {title}
                        </h4>

                        <div className="kuda-modal-illustration withdrawal-illustration">
                            {deleteIcon ? <DeleteIcon /> : <NoticeIcon />}
                        </div>

                        <div className="kuda-width--100 mt-4 pt-2">
                            <p className="color-black text-center">
                                <span className="text-normal color-black">{message}</span>
                            </p>
                        </div>
                        <div className="justify-center flex mt-4 pt-3">
                            {showCancel ? (
                                <Fragment>
                                    <div
                                        className={
                                            "addAction kuda-cta secondary-button mb-0 add-money cursor-pointer kuda-cta-wide"
                                        }
                                        onClick={onClose}
                                    >
                                        <span>{csv ? "Go back" : "Cancel"}</span>
                                    </div>

                                    <div
                                        className={`addAction kuda-cta mb-0 ml-3 kuda-cta-wide ${
                                            loading === "loading" ? "form-loading" : ""
                                        }`}
                                        onClick={onSubmit}
                                    >
                                        <span>{csv ? "Continue" : "Okay"}</span>
                                    </div>
                                </Fragment>
                            ) : (
                                <div
                                    className={`addAction kuda-cta kuda-cta-lg ${
                                        loading === "loading" ? "form-loading" : ""
                                    }`}
                                    onClick={onSubmit}
                                >
                                    <span>Okay</span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
